import styled from "styled-components";

const Search = styled.input`
  width: 100%;
  margin: 2rem 0;
  background-color: transparent;
  border: 1px solid var(--primary-text-color);
  color: var(--primary-text-color);
  padding: 0.3rem;
  border-width: 0.1rem;
  font-size: 1.2rem;
`;

export default Search;
